import type { FunctionComponent } from 'react';
import { Button } from '@fff-web/fff-ui-shared';
import * as styles from './Benefits.module.css';

const CTA_VARIATION = 'primary-outline';
const CTA_WIDTH = 284;
export interface BenefitProps {
  image: string;
  altImage: string;
  description: string;
  ctaText: string;
  ctaLink: string;
}

export interface BenefitsProps {
  benefits: BenefitProps[];
  isDesktop: boolean;
}

const handleClickBenefit = (link: string) => {
  window.location.href = link;
};

const Benefits: FunctionComponent<BenefitsProps> = ({ benefits, isDesktop }) => (
  <div className={styles.benefitsContainer} data-testid="benefits-container">
    {benefits.map((benefit, index) => {
      const isFullSizeBenefit = index === 2;
      const isLogoBenefit = index === 4;
      const benefitStyles = isLogoBenefit
        ? `${styles.benefit} ${styles.logoBenefit}`
        : `${styles.benefit}`;
      const benefitKey = `${index}`;

      return (
        <div key={benefitKey} data-testid="benefit">
          <div className={benefitStyles}>
            <img className={styles.image} src={benefit.image} alt={benefit.altImage} />
            <div className={styles.descriptionContainer}>
              <p className={styles.description}>
                {benefit.description}
                {isFullSizeBenefit && <sup className={styles.legalReference}>1</sup>}
              </p>
              {isDesktop && (
                <Button
                  variation={CTA_VARIATION}
                  width={CTA_WIDTH}
                  onClick={() => handleClickBenefit(benefit.ctaLink)}
                >
                  {benefit.ctaText}
                </Button>
              )}
            </div>
          </div>
          {!isDesktop && (
            <Button variation={CTA_VARIATION} onClick={() => handleClickBenefit(benefit.ctaLink)}>
              {benefit.ctaText}
            </Button>
          )}
        </div>
      );
    })}
  </div>
);

export default Benefits;
